export default __webpack_public_path__ + "static/bg-f8e35e7710dac1a2e1ccb2ff5d6077ba.png";